<template>
  <div>
    <table
      v-intersect.once
      class="youtube-list__table">
      <thead class="youtube-list__thead">
        <tr>
          <th class="youtube-list__cell-report-title"></th>
          <th
            v-for="(column, index) in columns"
            :key="`col-${index}`"
            class="youtube-list__cell-report-data">
            <a
              href="#"
              class="sort-link"
              @click="onSortKeyChanged(column.key)">
              {{ column.title }}
              <span v-if="sortKey === column.key">
                {{ sortOrder ? '▲' : '▼' }}
              </span>
            </a>
          </th>
        </tr>
      </thead>
      <tbody
        v-if="reports && reports.length > 0"
        class="youtube-list__tbody">
        <tr
          v-for="report in reports"
          :key="report.id">
          <td>
            <img
              :src="report.thumbnail"
              :alt="report.videoId"
              width="80px" />
            <div style="font-size: 12px; color: grey">
              {{ report.title }}
            </div>
          </td>
          <td class="number">¥{{ report.rpm }}</td>
          <td class="number">{{ report.views | number }}</td>
          <td class="number">{{ report.redViews | number }}</td>
          <td class="number">¥{{ report.estimatedRevenue | number }}</td>
          <td class="number">¥{{ report.estimatedAdRevenue | number }}</td>
          <td class="number">¥{{ report.estimatedRedPartnerRevenue | number }}</td>
          <td class="number">¥{{ report.grossRevenue | number }}</td>
          <td class="number">{{ report.averageViewDuration }}</td>
          <td class="number">{{ report.averageViewPercentage }}%</td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
export default {
  name: 'YouTubeClaimsReportTable',
  components: {
  },
  props: {
    reports: {
      type: Array,
      default: () => [],
    },
    sortKey: {
      type: String,
      default: 'views',
    },
    sortOrder: {
      type: Boolean,
      default: false,
    },
    columns: {
      type: Array,
      default: () => [
        { key: 'adImpressions', title: 'RPM' },
        { key: 'views', title: '視聴回数' },
        { key: 'redViews', title: 'YouTube Premium の視聴回数' },
        { key: 'estimatedRevenue', title: 'パートナーの想定収益' },
        { key: 'estimatedAdRevenue', title: 'パートナーの推定広告収益' },
        { key: 'estimatedRedPartnerRevenue', title: 'YouTube Premium パートナーの収益' },
        { key: 'grossRevenue', title: 'パートナーのトランザクション収益' },
        { key: 'averageViewDuration', title: '平均視聴時間' },
        { key: 'averageViewPercentage', title: '平均再生率（％）' },
      ],
    },
  },
  data() {
    return {
    }
  },
  methods: {
    onSortKeyChanged(key) {
      if (key === 'adImpressions') {
        return
      }
      this.$emit('on-change-sort', key)
    },
  },
}
</script>

<style scoped>
.error-message {
  color: #ff0000;
  font-size: 16px;
  margin: 20px auto 120px 20px;
  text-align: left;
}
.number {
  text-align: right;
  font-size: 12px;
}
</style>
